import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const meniereDisease: AnswerPathTreeNode = {
  path: 'meniereDisease',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredMeniereDiseaseDetails }],
};
